import React from 'react';
import {
  View,
  Text,
  StyleSheet,
} from 'react-native';
import { LINKED_ACCOUNTS_COLORS } from '@/constants/residents/mobile/linkedAccountsColors';

interface MobileEmptyStateProps {
  /** SVG icon component to display */
  icon: React.ReactNode;
  /** Title text */
  title: string;
  /** Description text */
  description: string;
  /** Custom icon container width (default: 68) */
  iconWidth?: number;
  /** Custom icon container height (default: 68) */
  iconHeight?: number;
}

/**
 * Mobile Empty State Component
 * Reusable dark theme empty state for linked accounts/invitations
 * Matches Figma design patterns
 */
export const MobileEmptyState: React.FC<MobileEmptyStateProps> = ({
  icon,
  title,
  description,
  iconWidth = 68,
  iconHeight = 68,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* Icon */}
        <View style={[styles.iconContainer, { width: iconWidth, height: iconHeight }]}>
          {icon}
        </View>

        {/* Text */}
        <View style={styles.textContainer}>
          <Text style={styles.title}>{title}</Text>
          <Text style={styles.description}>{description}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 90, // Offset for visual centering
  },
  content: {
    alignItems: 'center',
    gap: 18,
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    alignItems: 'center',
    gap: 6,
    width: 240,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: LINKED_ACCOUNTS_COLORS.textPrimary,
    textAlign: 'center',
    lineHeight: 24,
  },
  description: {
    fontSize: 14,
    fontWeight: '400',
    color: LINKED_ACCOUNTS_COLORS.textMuted,
    textAlign: 'center',
    lineHeight: 21,
  },
});

